import React, { useEffect, useRef, useState } from "react"
import { Row, Col, Form, Button } from "reactstrap"
import Select from "react-select"
import { Slider } from "primereact/slider"
import { InputText } from "primereact/inputtext"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { useTranslation } from "react-i18next"
import { showAlert } from "store/reducers/alertReducer"
import { useDispatch } from "react-redux"

const Filters = ({
  filters,
  searchTerm,
  appVersion = false,
  handleSearchChange,
  handleFilterChange,
  handleSearch,
  onReset = () => {},
  isCustomPageSize,
  selectedFilters,
  pageSizes,
  itemsPerPage,
  setItemsPerPage,
  isRangeSlider,
  priceRange,
  setPriceRange,
  hideSearch,
  isRangeDate,
  dateRange,
  setDateRange,
  flatpickrRef,
  searchBy,
  colSize,
  onInputChange,
  isAgeRange = false,
  ageRange,
  setAgeRange = "",
  tempAgeRange = {},
  setTempAgeRange = {},
  handleAppVersionChange = () => {},
  isSecondSearch = false,
  searchTerm2 = "",
  searchBy2 = "",
  handleSearchChange2 = () => {},
  onInputChangeSingle = () => {},
}) => {
  const { t } = useTranslation()
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const [selectedMenuOpen, setSelectedMenuOpen] = useState(null)

  const dispatch = useDispatch()

  const handleBlur = () => {
    // Close the dropdown when clicking outside
    setMenuIsOpen(false)
  }

  const prevSearchTermRef = useRef("")
  const prevSearchTermRef2 = useRef("")

  const handleSearchClick = () => {
    // Gather selected filter values and search term
    // const selectedFilters = {}
    // filters.forEach(filter => {
    //   if (filter.type === "select") {
    //     selectedFilters[filter.name] = filter.selectedValue
    //   }
    // })
    handleSearch()
  }

  useEffect(() => {
    if (isAgeRange) {
      const timer = setTimeout(() => {
        if (tempAgeRange.min !== "" && tempAgeRange.max !== "") {
          const min = parseInt(tempAgeRange.min)
          const max = parseInt(tempAgeRange.max)

          // Ensure min is not greater than max
          if (min > max) {
            dispatch(
              showAlert({
                text: t("Min age cannot be greater than Max age"),
                type: "error",
              })
            )
          } else {
            setAgeRange({ min, max })
          }
        }
      }, 500)
      return () => clearTimeout(timer)
    }
  }, [tempAgeRange])

  const handleTempAgeChange = (e, type) => {
    const value = e.target.value
    setTempAgeRange(prev => ({
      ...prev,
      [type]: value,
    }))
  }

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === "Enter") {
        // Prevent default behavior if inside a textarea
        if (e.target.tagName === "TEXTAREA") return
        
        e.preventDefault()
        handleSearch() // Trigger search
      }
    }

    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [handleSearch])

  useEffect(() => {
    if (prevSearchTermRef.current !== "" && searchTerm.trim() === "") {
      handleSearch() // Trigger search only when searchTerm is cleared
    }

    prevSearchTermRef.current = searchTerm // Update previous value
  }, [searchTerm])

  useEffect(() => {
    if (prevSearchTermRef2.current !== "" && searchTerm2.trim() === "") {
      handleSearch() // Trigger search only when searchTerm is cleared
    }

    prevSearchTermRef2.current = searchTerm2 // Update previous value
  }, [searchTerm2])

  return (
    <Form>
      <Row className="mb-3 pb-3 border-bottom">
        {hideSearch ? null : (
          <Col
            xl={colSize ? colSize : null}
            className={colSize ? "mb-3" : null}
          >
            <div className="d-flex position-relative">
              <input
                name="search"
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder={` ${searchBy ? searchBy : t("Keyword")}`}
                title={` ${searchBy ? searchBy : t("Keyword")}`}
                className="ps-4 form-control "
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    e.preventDefault() // Prevent default form submission (if applicable)
                  }
                }}
              />
              <i
                className="bx bx-search-alt-2"
                style={{
                  position: "absolute",
                  left: 16,
                  fontSize: 20,
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  opacity: "0.9",
                }}
              ></i>
            </div>
          </Col>
        )}
        {isSecondSearch && (
          <Col
            xl={colSize ? colSize : null}
            className={colSize ? "mb-3" : null}
          >
            <div className="d-flex position-relative">
              <input
                name="search"
                type="text"
                value={searchTerm2}
                onChange={handleSearchChange2}
                placeholder={searchBy2}
                title={searchBy2}
                className="ps-2 form-control "
              />
            </div>
          </Col>
        )}
        {filters.map((filter, index) => (
          <Col
            key={index}
            xl={colSize ? colSize : null}
            className={colSize ? "mb-3" : null}
          >
            {filter.type === "select" && (
              <select
                className="form-select"
                value={selectedFilters[filter.name]}
                onChange={e => handleFilterChange(e.target.value, filter.name)}
              >
                <option hidden>{filter.placeholder}</option>
                {filter.options.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}
            {filter.type === "multiSelect" && (
              <Select
                value={selectedFilters[filter.name]}
                isMulti={true}
                onChange={selectedOption => {
                  handleFilterChange(selectedOption, filter.name)
                }}
                options={filter.options}
                placeholder={filter.placeholder}
                className="select2-selection"
                // menuIsOpen={menuIsOpen && selectedMenuOpen === filter.name}
                // onBlur={handleBlur}
                // onFocus={() => {
                //   setMenuIsOpen(true)
                //   setSelectedMenuOpen(filter.name)
                // }}
                onInputChange={onInputChange}
                closeMenuOnSelect={false}
              />
            )}
            {filter.type === "singleSelect" && (
              <Select
                value={selectedFilters[filter.name]}
                isMulti={false}
                onChange={selectedOption => {
                  handleFilterChange(selectedOption, filter.name)
                }}
                options={filter.options}
                placeholder={filter.placeholder}
                className="select2-selection"
                onInputChange={onInputChangeSingle}
              />
            )}
          </Col>
        ))}
        {isRangeDate && (
          <Col
            xl={colSize ? colSize : null}
            className={colSize ? "mb-3" : null}
          >
            <Flatpickr
              className="form-control d-block"
              placeholder={t("Date")}
              ref={flatpickrRef}
              options={{
                mode: "range",
                dateFormat: "Y-m-d",
                defaultDate: [dateRange.min, dateRange.max], // Set default date range
                // defaultDate: [new Date("2024-05-01"), new Date("2024-05-21")],
              }}
              onChange={selectedDates => {
                const formattedDates = selectedDates.map(
                  date =>
                    date
                      .toLocaleDateString("en-CA", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                      .split("/")
                      .reverse()
                      .join("-") // Format to "yyyy-mm-dd"
                )
                const minDate = formattedDates[0]
                const maxDate = formattedDates[1]
                setDateRange({
                  min: minDate,
                  max: maxDate,
                })
              }}
            />
          </Col>
        )}

        {isRangeSlider && (
          <Col
            xl={colSize ? colSize : null}
            className={colSize ? "mb-3" : null}
          >
            <div className="">
              <InputText
                value={priceRange[0]}
                onChange={e => {
                  const newValue = parseInt(e.target.value)
                  if (!isNaN(newValue)) {
                    setPriceRange([
                      Math.min(Math.max(newValue, 0), 1000),
                      priceRange[1],
                    ])
                  }
                }}
                className="w-50"
                type="number"
                placeholder="Search range"
              />
              <InputText
                value={priceRange[1]}
                type="number"
                onChange={e => {
                  const newValue = parseInt(e.target.value)
                  if (!isNaN(newValue)) {
                    setPriceRange([priceRange[0], Math.min(newValue, 1000)])
                  }
                }}
                className="w-50"
                placeholder="Search range"
              />
              <Slider
                value={priceRange}
                onChange={e => setPriceRange([e.value[0], e.value[1]])}
                className="w-full"
                range
                min={0}
                max={1000}
              />
            </div>
          </Col>
        )}

        {isAgeRange && (
          <Col
            xl={colSize ? colSize : null}
            className={colSize ? "mb-3" : null}
          >
            <div className="">
              <InputText
                value={tempAgeRange.min}
                onChange={e => handleTempAgeChange(e, "min")}
                className="w-50"
                type="number"
                placeholder={t("Min Age")}
              />
              <InputText
                value={tempAgeRange.max}
                onChange={e => handleTempAgeChange(e, "max")}
                className="w-50"
                type="number"
                placeholder={t("Max Age")}
              />
            </div>
          </Col>
        )}

        <Col xl={colSize ? colSize : null} className={colSize ? "mb-3" : null}>
          <div className="d-flex justify-content-start gap-3">
            <Button
              color="success"
              onClick={handleSearchClick}
              className="g_center d-flex w-50"
              style={{ minWidth: 40, height: 39, padding: "0 10px" }}
            >
              <i className="bx bx-search-alt-2 mx-1" style={{ fontSize: 22 }}></i>{" "}
              {t("Search")}
            </Button>
            <Button
              color="success"
              onClick={onReset}
              className="g_center d-flex btn-light w-50"
              style={{ minWidth: 40, height: 39, padding: "0 10px" }}
            >
              <i className="mdi mdi-refresh mx-1" style={{ fontSize: 22 }}></i>{" "}
              {t("Reset")}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default Filters

/* {isCustomPageSize && (
          <Col>
            <select
              className="form-select pageSize mb-2"
              value={itemsPerPage}
              onChange={e => {
                setItemsPerPage(e.target.value)
              }}
            >
              {pageSizes.map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        )} */
/* {isCustomPageSize && (
          <Col>
            <select
              className="form-select pageSize mb-2"
              value={itemsPerPage}
              onChange={e => {
                setItemsPerPage(e.target.value)
              }}
            >
              {pageSizes.map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        )} */
